import { dataHooks } from '../../../libs/dataHooks';

export const paginationDataHooks = dataHooks<{ button; text }>('pagination');
